/**
 * Attempts to parse a content string as a JSON dashboard tree.
 *
 * @param {string} content - The dashboard content string
 * @returns {Object|null} Parsed JSON tree if valid dashboard, null otherwise
 */
export const safeParseDashboardJson = (content) => {
  if (!content || typeof content !== "string") {
    return null;
  }

  try {
    const parsed = JSON.parse(content);

    if (parsed && typeof parsed === "object" && parsed.type === "dashboard") {
      return parsed;
    }

    return null;
  } catch {
    return null;
  }
};
